import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { Currency, Rate } from '@iw/core/entities';
import { environment } from '@iw/environment';

import { DictionariesApi } from './dictionaries-api.interface';
import { GetDictionaryRes } from '../models';

@Injectable()
export class DictionariesApiService implements DictionariesApi {
  readonly #http = inject(HttpClient);
  readonly #apiHost = environment.apiHost;

  getCurrencies(): Observable<Currency[]> {
    const api = `${this.#apiHost}currencies/`;

    return this.#http
      .get<GetDictionaryRes<Currency>>(api)
      .pipe(map((res) => res.items));
  }

  getRates(): Observable<Rate[]> {
    const api = `${this.#apiHost}rates/`;

    return this.#http
      .get<GetDictionaryRes<Rate>>(api)
      .pipe(map((res) => res.items));
  }
}
